import { Spinner } from "../ui/Spinner"
import { Dialog } from "@/components/ui/Dialog"
import { useTranslation } from "react-i18next"
import { useAtom } from "jotai/index"
import { metadataAtom } from "@/store/photo/photos-state"
import { projectAtom } from "@/store/project/projects-state"

export const LoadingDialog = (props: { title?: string; content?: string }) => {
	return RenderCommonLoadingDialog(props.title, props.content)
}

export const ImportLoadingDialog = () => {
	const { t } = useTranslation("components")
	const [metadata] = useAtom(metadataAtom)
	const [project] = useAtom(projectAtom)

	const completedMetadataLength = Object.values(metadata).filter((m) => m.isComplete).length
	const title = t("loadingDialog.importingPhotos", {
		completed: completedMetadataLength,
		total: project?.photoCount,
	})
	const content = t("loadingDialog.doNotClose")
	return RenderCommonLoadingDialog(title, content)
}

function RenderCommonLoadingDialog(title?: string, content?: string) {
	return (
		<Dialog trackingViewName="import_loading_dialog" disableClose>
			<div className="flex w-[462px] flex-col space-y-3">
				<div className="flex flex-row items-center justify-between">
					{title && <div className="text-md font-bold">{title}</div>}
					<Spinner size={24} />
				</div>
				{content && <div className="text-xs">{content}</div>}
			</div>
		</Dialog>
	)
}
